import { render, staticRenderFns } from "./star.vue?vue&type=template&id=718032cf&"
import script from "./star.js?vue&type=script&lang=js&"
export * from "./star.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports